// @flow

export const SET_PDB_ID: 'listo/pdbComparison/SET_PDB_ID' = 'listo/pdbComparison/SET_PDB_ID';
export const UNSET_PDB_ID: 'listo/pdbComparison/UNSET_PDB_ID' = 'listo/pdbComparison/UNSET_PDB_ID';
export const RECEIVE_PDB_IDS: 'listo/pdbComparison/RECEIVE_PDB_IDS' = 'listo/pdbComparison/RECEIVE_PDB_IDS';
export const UNSET_ALL_PDB_IDS: 'listo/pdbComparison/UNSET_ALL_PDB_IDS' = 'listo/pdbComparison/UNSET_ALL_PDB_IDS';

export default null;
